import { Link, useRouteError } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function ErrorPage() {
  const error = useRouteError() as
    | { statusText?: string; message?: string }
    | undefined;

  return (
    <div className="flex min-h-screen w-full items-center justify-center p-6">
      <div className="animate-page-enter text-center">
        <h1 className="text-2xl">Something went wrong</h1>
        <p className="text-muted-foreground mt-2 text-sm">
          {error?.statusText || error?.message || "An unexpected error occurred."}
        </p>
        <Button asChild className="mt-6">
          <Link to="/">Go home</Link>
        </Button>
      </div>
    </div>
  );
}
